// extracted by mini-css-extract-plugin
export default {"viewItem":"view-form_viewItem__aKt+k","viewItemValue":"view-form_viewItemValue__3kG3t"};